import { UPLOAD_SP_SET_MALL, UPLOAD_SP_SET_STORE } from '../types';

export const setMall = (id, name) => async (dispatch) => {
  dispatch({
    type:    UPLOAD_SP_SET_MALL,
    payload: {
      id, name,
    },
  });
};

export const setStore = (id, name, outletId, postalCode) => async (dispatch) => {
  dispatch({
    type:    UPLOAD_SP_SET_STORE,
    payload: {
      id, name, outletId, postalCode,
    },
  });
};
